/**
 * TalentDetail 인메모리 캐시 (세션 단위)
 * 같은 배우 프로필을 여러 페이지에서 반복 요청하는 것을 방지
 * TTL: 5분
 */
const CACHE_TTL_MS = 5 * 60 * 1000;
const cache = new Map(); // key: idOrSlug → { data, expiresAt }

export function getCachedTalentDetail(idOrSlug) {
  const entry = cache.get(String(idOrSlug));
  if (!entry) return null;
  if (Date.now() > entry.expiresAt) {
    cache.delete(String(idOrSlug));
    return null;
  }
  return entry.data;
}

export function setCachedTalentDetail(idOrSlug, data) {
  cache.set(String(idOrSlug), {
    data,
    expiresAt: Date.now() + CACHE_TTL_MS,
  });
}

export function invalidateTalentDetail(idOrSlug) {
  cache.delete(String(idOrSlug));
}
